import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_ProductRequestDetail_Interface, ProductRequestDetail_Interface } from 'src/app/Interface/ProductRequestDetail_Interface';
import { Empty_Product_Interface, Product_Interface } from 'src/app/Interface/Product_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { ProductService } from 'src/app/Service/Product/Product.service';
import { ProductRequestService } from 'src/app/Service/ProductRequest/ProductRequest.service';

@Component({
  selector: 'app-ProductRequestAdd',
  templateUrl: './ProductRequestAdd.component.html',
  styleUrls: ['./ProductRequestAdd.component.scss']
})
export class ProductRequestAddComponent implements OnInit {

  Token: String = ""

  constructor(
    private Product_Service: ProductService,
    private ProductRequest_Service: ProductRequestService,
    private Nav_Service: NavService,
    private Alertify_Service: AlertifyService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');

    this.AddNewProduct = new FormGroup({
      id: new FormControl(),
      Dsc: new FormControl(null, Validators.required),
      Amount: new FormControl(null),
      Price: new FormControl(null),
    })


    this.Nav_Service.CheckValidPage(this.Token, 2208).subscribe(
      data => {
        this.ReadData_Product()
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )


  }

  //#region  Product

  modalRef_Product: any;

  ProcssingProduct: boolean = false

  Search_Name_Product_Table: string = ''


  openModal_Product(template: TemplateRef<any>) {
    this.modalRef_Product = this.modalService.show(template);
  }

  DataList_Product: Array<Product_Interface> = []
  Data_Seleted_Product_Record: Product_Interface = Empty_Product_Interface()

  ReadData_Product_KeySearch_Timer: any
  ReadData_Product_KeySearch() {

    if (this.ReadData_Product_KeySearch_Timer) {
      clearTimeout(this.ReadData_Product_KeySearch_Timer);
      this.ReadData_Product_KeySearch_Timer = null;
    }

    this.ReadData_Product_KeySearch_Timer = setTimeout(function () {
      this.ReadData_Product()
    }.bind(this), 1000);

  }

  ReadData_Product() {

    if (!this.Search_Name_Product_Table) {
      this.DataList_Product = []
    }
    else {
      this.ProcssingProduct = true
      this.Product_Service.GetSearchProduct(this.Token, this.Search_Name_Product_Table).subscribe(
        data => {
          this.DataList_Product = data
          this.ProcssingProduct = false
        }, error => {
          localStorage.clear()
          location.reload();

        }
      )
    }
  }

  Set_Selected_Product_Record(item) {
    this.Data_Seleted_Product_Record = item
    this.modalRef_Product.hide()
  }

  //#endregion

  //#region  Form Add

  AddNewProduct: FormGroup;

  get_Form_Amount() {
    return this.AddNewProduct.get('Amount') as FormControl;
  }

  get_Form_Dsc() {
    return this.AddNewProduct.get('Dsc') as FormControl;
  }

  get_Form_Price() {
    return this.AddNewProduct.get('Price') as FormControl;
  }

  //#endregion

  //#region Dscs

  Datalist_Dsc: Array<General_Interface> = []

  Remove_Dsc(index: number) {
    this.Datalist_Dsc.splice(index, 1)
    this.Alertify_Service.SuccessMessage("Information deleted successfully.")
  }

  Add_Dsc() {
    this.Datalist_Dsc.push(Empty_General_Interface())
    this.Alertify_Service.SuccessMessage("A new row was added.")
  }

  //#endregion

  //#region Product Request

  Total_Price_Detail: number = 0
  DataList_ProductRequestDetail: Array<ProductRequestDetail_Interface> = []

  OnAdd_ProductRequestDetail() {

    var CheckProduct: boolean = false
    for (let item of this.DataList_ProductRequestDetail) {
      if (item.id == this.Data_Seleted_Product_Record.id) {
        CheckProduct = true
        break;
      }
    }

    if (this.Data_Seleted_Product_Record.id == 0) {
      this.Alertify_Service.ErrorMessage("No product has been selected.")
    }
    else if (CheckProduct) {
      this.Alertify_Service.ErrorMessage("The selected product already exists in the list.")
    }
    else {
      var temp: ProductRequestDetail_Interface = Empty_ProductRequestDetail_Interface()
      temp.id = this.Data_Seleted_Product_Record.id
      temp.amount = Number(this.get_Form_Amount().value)
      temp.price = Number(this.get_Form_Price().value)
      temp.title = this.Data_Seleted_Product_Record.title

      this.DataList_ProductRequestDetail.push(temp)
      this.Alertify_Service.SuccessMessage("The product was added to the list.")
      this.Cal_Total_Price_Detail()
    }

  }

  Cal_Total_Price_Detail() {
    this.Total_Price_Detail = 0
    for (let item of this.DataList_ProductRequestDetail) {
      this.Total_Price_Detail = this.Total_Price_Detail + (item.price * item.amount)
    }
  }


  Delete_ProductRequestDetail(index: number) {
    this.DataList_ProductRequestDetail.splice(index, 1)
    this.Alertify_Service.SuccessMessage("The selected product was removed.")
    this.Cal_Total_Price_Detail()
  }

  //#endregion

  InProccessing: boolean = false

  SubmitAddNewProduct() {

    if (this.DataList_ProductRequestDetail.length == 0) {
      this.Alertify_Service.ErrorMessage("Select a product.")
    }
    else {

      var tempDsc: Array<string> = []
      for (let item of this.Datalist_Dsc) {
        tempDsc.push(item.title + '')
      }

      var tempProductRequestDetail: Array<any> = []
      for (let item of this.DataList_ProductRequestDetail) {
        tempProductRequestDetail.push({
          product_id: item.id,
          amount: item.amount,
          price: item.price,
        })
      }

      this.ProductRequest_Service.AddProductRequest(
        this.get_Form_Dsc().value,
        tempDsc,
        tempProductRequestDetail,
        this.Token).subscribe(
          data => {
            if (data.id == -1) {
              this.Alertify_Service.ErrorMessage("No active workflow has been selected for the purchase request.")
            }
            else if (data.id == -2) {
              this.Alertify_Service.ErrorMessage("System error.")
            }
            else if (data.id == -3) {
              this.Alertify_Service.ErrorMessage("You do not have a position in the organizational chart.")
            }
            else {
              this.InProccessing = false
              this.AddNewProduct.reset()
              this.Alertify_Service.SuccessMessage("Information saved successfully.")
              this.Datalist_Dsc = []
              this.DataList_ProductRequestDetail = []
              this.AddNewProduct.reset()
              this.Data_Seleted_Product_Record = Empty_Product_Interface()
            }
          }, error => {
            localStorage.clear()
            location.reload();

          }
        )
    }
  }

}



